import data from "../../../../../src/Heading/Heading.docs.json";
import * as React from 'react';
export default {
  data,
  React
};